var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "19px",
    viewBox: "0 0 11 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "round-arrow_forward_ios-24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-+-notifications",
    transform: "translate(-1046.000000, -354.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "round-arrow_forward_ios-24px",
    transform: "translate(1039.000000, 351.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bounding_Boxes",
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "24 24 0 24 0 0 24 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rounded",
    transform: "translate(7.000000, 3.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.377642515,18.6278977 C0.879445857,19.1240341 1.68847574,19.1240341 2.19027908,18.6278977 L10.7004541,10.2138289 C11.0998486,9.81894484 11.0998486,9.18105516 10.7004541,8.78617106 L2.19027908,0.372102318 C1.68847574,-0.124034106 0.879445857,-0.124034106 0.377642515,0.372102318 C-0.124160827,0.868238742 -0.124160827,1.66813216 0.377642515,2.16426859 L7.79204292,9.50506262 L0.367401631,16.8458566 C-0.124160827,17.3318678 -0.124160827,18.1418865 0.377642515,18.6278977 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.0c209120506cf999aa929942a1c82741.svg";
export { ForwardRef as ReactComponent };